import { render } from "./InquiryConclusions.vue?vue&type=template&id=07b67202&scoped=true"
import script from "./InquiryConclusions.vue?vue&type=script&lang=js"
export * from "./InquiryConclusions.vue?vue&type=script&lang=js"

import "./InquiryConclusions.vue?vue&type=style&index=0&id=07b67202&scoped=true&lang=css"

import exportComponent from "E:\\c2stem\\c2-stem-classroom-inquiry\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07b67202"]])

export default __exports__